import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const GeneralProductListing = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14938)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECFEFF"
          />
          <rect
            x="77.75"
            y="36.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M166.188 37L79 90.2C79 90.2 79.6124 91.6548 80.7024 92.1799C81.7925 92.705 83.2709 93 84.8125 93H166.188C167.729 93 169.208 92.705 170.298 92.1799C171.388 91.6548 172 90.9426 172 90.2V39.8C172 39.0574 171.388 38.3452 170.298 37.8201C169.208 37.295 166.188 37 166.188 37Z"
            fill="#E3E3E3"
          />
          <path
            d="M100.674 49.9957H134.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.674 57.71H144.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.674 65.4243H134.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.674 73.1386H144.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.674 80.8529H144.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="77.75"
            y="36.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M55.5961 50.6141L58.0015 53.0195L66.0194 45.0016L63.614 42.5962C62.545 41.5613 61.112 40.9881 59.6241 41.0002C58.1363 41.0123 56.7128 41.6087 55.6607 42.6608C54.6086 43.7129 54.0122 45.1364 54.0001 46.6242C53.988 48.1121 54.5612 49.5451 55.5961 50.6141Z"
            fill="#FF808C"
          />
          <path
            d="M74.7749 69.7928L86 73L82.7928 61.7749L74.7749 69.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M66.0194 45.0048L82.7928 61.7783L74.7749 69.7962L58.0015 53.0227L66.0194 45.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M55.5961 50.6141L58.0015 53.0195L66.0194 45.0016L63.614 42.5962C62.545 41.5613 61.112 40.9881 59.6241 41.0002C58.1363 41.0123 56.7128 41.6087 55.6607 42.6608C54.6086 43.7129 54.0122 45.1364 54.0001 46.6242C53.988 48.1121 54.5612 49.5451 55.5961 50.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.7749 69.7928L86 73L82.7928 61.7749L74.7749 69.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M66.0194 45.0048L82.7928 61.7783L74.7749 69.7962L58.0015 53.0227L66.0194 45.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M176.461 97.2337H154.899C154.422 97.2338 153.957 97.0812 153.572 96.7983C153.187 96.5154 152.903 96.117 152.761 95.6611L150.428 88.1936C150.323 87.8584 150.299 87.5032 150.357 87.1567C150.415 86.8103 150.553 86.4823 150.761 86.1993C150.969 85.9163 151.241 85.6862 151.554 85.5275C151.868 85.3688 152.214 85.286 152.565 85.2858H178.131C178.454 85.2869 178.769 85.182 179.027 84.9871L177.656 97.8102C177.52 97.623 177.339 97.4724 177.131 97.3718C176.922 97.2712 176.692 97.2238 176.461 97.2337Z"
            fill="#C2F3FF"
          />
          <path
            d="M157.725 92.9235C157.248 92.9234 156.783 92.7709 156.399 92.4883C156.015 92.2057 155.73 91.8077 155.588 91.3524L153.691 85.2858H152.565C152.214 85.286 151.868 85.3688 151.554 85.5275C151.241 85.6862 150.969 85.9163 150.761 86.1993C150.553 86.4824 150.415 86.8103 150.357 87.1568C150.299 87.5032 150.323 87.8584 150.428 88.1937L152.761 95.6611C152.903 96.117 153.187 96.5154 153.572 96.7983C153.957 97.0812 154.422 97.2338 154.899 97.2337H176.461C176.692 97.2239 176.922 97.2714 177.131 97.372C177.339 97.4725 177.52 97.6231 177.656 97.8102L178.177 92.9235H157.725Z"
            fill="#66E1FF"
          />
          <path
            d="M184.675 79.3118H180.855C180.672 79.3105 180.494 79.3765 180.357 79.4974C180.219 79.6183 180.13 79.7856 180.108 79.9675L179.612 83.976C179.567 84.3374 179.392 84.67 179.119 84.9112C178.846 85.1525 178.495 85.2857 178.131 85.2858H152.565C152.214 85.286 151.868 85.3688 151.554 85.5275C151.241 85.6862 150.969 85.9163 150.761 86.1993C150.553 86.4823 150.415 86.8103 150.357 87.1567C150.299 87.5032 150.323 87.8584 150.428 88.1936L152.761 95.6611C152.903 96.1169 153.187 96.5154 153.572 96.7983C153.957 97.0812 154.422 97.2338 154.899 97.2337H176.461C176.857 97.2337 177.237 97.3911 177.517 97.6712C177.797 97.9512 177.954 98.3311 177.954 98.7272C177.954 99.1233 177.797 99.5032 177.517 99.7833C177.237 100.063 176.857 100.221 176.461 100.221H155.552"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M178.703 88.2728L178.043 94.2139"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M158.541 107.688C159.135 107.688 159.704 107.452 160.125 107.032C160.545 106.612 160.781 106.042 160.781 105.448C160.781 104.854 160.545 104.284 160.125 103.864C159.704 103.444 159.135 103.208 158.541 103.208C157.946 103.208 157.377 103.444 156.956 103.864C156.536 104.284 156.3 104.854 156.3 105.448C156.3 106.042 156.536 106.612 156.956 107.032C157.377 107.452 157.946 107.688 158.541 107.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M174.969 107.688C175.563 107.688 176.133 107.452 176.553 107.032C176.973 106.612 177.209 106.042 177.209 105.448C177.209 104.854 176.973 104.284 176.553 103.864C176.133 103.444 175.563 103.208 174.969 103.208C174.375 103.208 173.805 103.444 173.385 103.864C172.965 104.284 172.729 104.854 172.729 105.448C172.729 106.042 172.965 106.612 173.385 107.032C173.805 107.452 174.375 107.688 174.969 107.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14938">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
